module.exports = __webpack_public_path__ + "static/media/homeSkeletonLg.352c3cc4.svg";